<template>
  <div>
    <apex-chart height="175"
                ref="chart"
                type="bar"
                :options="chartOptions"
                :series="series"/>
  </div>
</template>
<script>

export default {
  // 공정 에너지별 배출량 비율
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  data() {
    return {
      categories: [],
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%'
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
          labels: {
            show: false
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            formatter: val => this.formatNumber(val) + ' tCO2'
          }
        },
        grid: {
          show: false
        },
        legend: {
          show: true,
          position: 'bottom',
        },
      },
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return

      try {
        // Chart meta data
        let args = [{
          year: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['scope']
        }]

        // Construct form data for HTTP request
        let formData = new FormData()
        formData.append('path', 'esg/lca/energy_detail/main')
        formData.append('json', JSON.stringify(args))

        // Request data for the chart
        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', formData, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, throw an error
        if (!response.data.data) {
          return
        }

        // Parse JSON data
        let chartData = JSON.parse(response.data.data)[0].data

        // Group data based on LCA process and product name
        let scopes = ['생산 공정 - 에너지', '생산 공정 - 전력']
        let seriesMap = new Map()
        scopes.forEach((name, index) => {
          let ghg = chartData
              .filter(row => row.scope === (index + 1))
              .map(row => row.values)
              .pop() || 0
          if (seriesMap.has(name)) {
            const series = seriesMap.get(name)
            series.push(ghg)
          } else {
            seriesMap.set(name, [ghg])
          }
        })

        // Set series
        this.series = Array.from(seriesMap, ([name, data]) => ({ name, data }))
      } catch (error) {
        await this.showError(error)
      } finally {
        this.refreshChart()
      }
    },
  }
}
</script>
